var map = {
	"./Onboarding gif.svg": 3350,
	"./bill.svg": 4856,
	"./billing.svg": 8016,
	"./catalogues.svg": 2089,
	"./closeMenu.svg": 8304,
	"./dashboard.svg": 2437,
	"./essential.svg": 4645,
	"./feedback.svg": 8042,
	"./hamMenu.svg": 1146,
	"./help.svg": 1298,
	"./notification.svg": 5878,
	"./orders.svg": 3856,
	"./plans.svg": 6133,
	"./reports.svg": 9316,
	"./search.svg": 2887,
	"./settings.svg": 4524,
	"./shipyaariLogos.svg": 6373,
	"./shipyaarigrowth.svg": 7702,
	"./tracking.svg": 1392,
	"./wallet.svg": 4080,
	"./weightmanagement.svg": 2098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4383;